module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACTSURBVHgB7ZPbDUZAEIXP+BXwlzAVuHQkFEAJthMdUYIStgEZu4ggEdZ69D3tJHtO5pIDbIi5EFxw/BPAE4q4KAmozfsPN7RAVGjFhCHt+qZ3USecMfBrb819htX678Cng7UNPOSVEXYG9qQR59Xd2hLu3YS2nlf1xLeDd3ag52C4sWi0SaMoQdAaN6c4myhrAqkRFWc8+pmyWPAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/TeamBuilding/calendar-icon.png
// module id = 617
// module chunks = 0